import { COLORS } from '@mafc/common';
import { customStyled, Box } from '@mafc/trolly';

export const SponsoredProductsTitle = customStyled(Box)`
  color: ${COLORS.BLACK};
  font-weight: ${(props: any) => props.theme.fontWeights[5]};
  font-size: ${props => props.theme.fontSizes[3]}px;
  margin: 8px;
  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    margin: 12px;
    margin-left: 0;
  }
`;
